import React from "react";
import { Link } from "react-router-dom";

// Images \\
import doctors_avatar from "../../assets/images/doctorsAvatar.svg";

// Style \\
import "../../assets/styles/sections/doctorsProfileHero.scss";

// Icons \\
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const DoctorsProfileHero = () => {
  return (
    <section className="profile_hero">
      <div className="spaBg ">
        <div className="bg"></div>
        <img src={doctors_avatar} alt="" />
        <div className="container">
          <div className="profile_hero">
            <div className="text">
              <p>Home / portfolio</p>
              <h2>Dr Name of Doctor</h2>
              <p className="field">Surgery</p>
            </div>

            <div className="social_box">
              <Link className="socialLink">
                <div className="box">
                  <FaLinkedinIn className="icons" />
                </div>
              </Link>
              <Link className="socialLink">
                <div className="box">
                  <FaFacebookF className="icons" />
                </div>
              </Link>
              <Link className="socialLink">
                <div className="box">
                  <FaInstagram className="icons" />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DoctorsProfileHero;
